import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const SidebarLink = styled(Link)`

`;

/*
display: flex;
    color: #000000;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    list-style: none;
    height: 60px;
    text-decoration: none;
    font-size: 18px;


    &:hover {
        background: #f8f6f8;
        cursor: pointer;
    }
        */

const SidebarLabel = styled.span`
    margin-left: 16px;
`;




const SubMenu = ({ item, onNavigate }) => {
    const [subnav, setSubnav] = useState(false);


    const showSubnav = () => setSubnav(!subnav);

    // Clicking an app link navigates and lets the drawer close itself (QA issue 2).
    const handleClick = () => {
        if (item.subNav) showSubnav();
        if (onNavigate) onNavigate();
    };


    return (
        <>
            <SidebarLink
                to={item.path}
                onClick={handleClick}
                /*style={{marginBottom: "2.9vh"}}*/
            >
                <div className="flex-container">
                    {item.icon}
                    <SidebarLabel style={{fontSize: "14.74px", color: "#5e5c5e"}}>
                        {item.title}
                    </SidebarLabel>
                </div>
            </SidebarLink>

        </>
    );
};


export default SubMenu;
